import { useState, useEffect } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import { useCaptureException } from '@zenbusiness/application-commons-logging';

export default function useAnchorElement(entityMenuRef, buttonRef, eventProps) {
  const captureException = useCaptureException();
  const [anchorElement, setAnchorEl] = useState(null);

  const buttonPressedCallback = useButtonPressedCallback(eventProps);

  const onButtonClick = (event) => {
    buttonRef.current.blur();
    setAnchorEl(event.currentTarget);
    buttonPressedCallback();
  };

  const onMenuClose = () => {
    buttonRef.current.blur();
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!entityMenuRef.current) {
      return;
    }
    try {
      if (anchorElement) {
        entityMenuRef.current.querySelector('a')?.focus();
      }
    } catch (err) {
      captureException(err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchorElement, entityMenuRef.current]);

  return {
    anchorElement,
    onButtonClick,
    onMenuClose
  };
}
